module.exports = __webpack_public_path__ + "static/media/icon-success-green-checkmark.8ff327e6.svg";